import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken, verifyAuth } from "@/lib/api";

export default function ProtectedRoute({ children }) {
  const [state, setState] = useState("checking");
  const location = useLocation();

  useEffect(() => {
    if (!getToken()) {
      setState("denied");
      return;
    }
    verifyAuth()
      .then(() => setState("ok"))
      .catch(() => setState("denied"));
  }, []);

  if (state === "checking") {
    return (
      <p className="font-mono text-sm text-muted-foreground text-center py-32">
        Verifying access…
      </p>
    );
  }
  if (state === "denied") {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
